import { MenuProps } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AppMenuItem } from "../../../../shared/components/AppMenu/AppMenuItem";
import { AppMenu } from "../../../../shared/components/AppMenu";
import { UploadFileButton } from "../../../Components/Buttons/UploadFileButton";
import { TEntityInfo } from "../../../types/utility";
import { AppButton } from "../../../../shared/components/AppButton";
import { TModalsIds } from "../../../../app/state/modalSlice/types";
import styles from "./styles.module.css";

interface Props extends MenuProps {
  handleUploadFile: (event: React.ChangeEvent<HTMLInputElement>) => void;
  openAttachedFileModal: (id: TModalsIds, info: TEntityInfo | null) => void;
  closeMenu?: () => void;
  additionalOption?: React.ReactNode;
  multiple?: boolean;
  className?: string;
}

export const AttachedFileMenu = ({
  handleUploadFile,
  openAttachedFileModal,
  closeMenu,
  additionalOption,
  multiple,
  ...rest
}: Props) => {
  const { t } = useTranslation();

  const titlePC = multiple ? t("common.upload_files") : t("common.upload_file");
  const titleArtifacts = multiple
    ? t("common.save_files_from_artifacts")
    : t("common.save_file_from_artifacts");

  return (
    <AppMenu
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      anchorPosition={{ top: -100, left: 0 }}
      {...rest}
    >
      <AppMenuItem>
        <UploadFileButton
          icon={null}
          type={"button"}
          multiple={multiple}
          handleFileUpload={handleUploadFile}
          title={titlePC}
          className={styles["menu-btn"]}
        />
      </AppMenuItem>
      <AppMenuItem>
        <AppButton
          buttonType="text"
          onClick={() => openAttachedFileModal("attached_file_modal", null)}
          className={styles["menu-btn"]}
        >
          {titleArtifacts}
        </AppButton>
      </AppMenuItem>
      {additionalOption && (
        <AppMenuItem onClick={closeMenu}>{additionalOption}</AppMenuItem>
      )}
    </AppMenu>
  );
};
